import { useState, forwardRef, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Slide,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable.jsx";
import { submittedQuesAnsDetailTable } from "../../config/grid-column-defs.js";
import {
  getquestionAnswerById,
  postApproveReject,
} from "../../api/questionsAnswers.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useSnackbar from "../../hooks/useSnackbar.js";
import useErrorHandler from "../../hooks/useErrorHandler.js";

export default function SubmittedQuesAnsDetail() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const params = useParams();
  const { data: user } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [caseType, setCaseType] = useState(null);
  const [quesAnsStatus, setQuesAnsStatus] = useState("");
  const [questionsTableRefreshCount, setQuestionsTableRefreshCount] =
    useState(0);
  function refreshQuestionsTable() {
    setQuestionsTableRefreshCount((prev) => prev + 1);
  }

  useEffect(() => {
    refreshQuestionsTable();
  }, []);

  async function getQuestionTableData(limit, offset) {
    try {
      const { data } = await getquestionAnswerById(
        params.id,
        caseType,
        user.token,
        {
          limit,
          offset,
        }
      );
      setQuesAnsStatus(data.qusStatus);
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      errorHandler(error);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  const approveReject = async (status) => {
    try {
      const { data } = await postApproveReject(user.token, {
        user_id: params.id,
        status: status,
        case_type: caseType,
      });

      snackbar.showSuccess("succesfully");
      navigate("/submittedques");
    } catch (err) {
      errorHandler(err);
    }
  };
  useEffect(() => {
    if (state) {
      setCaseType(state.case_type);
    } else {
      navigate("/submittedques");
    }
  }, []);

  return (
    <>
      <Paper className="odr-card">
        <Box>
          <Box p={2} display="flex" justifyContent="space-between" alignItems="center" className="odr-card-header">
       
            <Typography className="heading-title">Question/Answers Details</Typography>
            {loading ? (
              <CircularProgress />
            ) : (
              <Box display="flex" justifyContent="flex-end" columnGap={2}>
                {/^approved$/i.test(quesAnsStatus) && (
                  <Button
                    className="lightBlue-button"
                    variant="contained"
                    size="large"
                    color="primary"
                    disabled={/^trial_user$/i.test(user.roles) ? true : false}
                    onClick={() => {
                      approveReject("rejected");
                    }}
                  >
                    Reject
                  </Button>
                )}
                {/^rejected$/i.test(quesAnsStatus) && (
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={() => {
                      approveReject("approved");
                    }}
                    disabled={/^trial_user$/i.test(user.roles) ? true : false}
                    className="blue-button"
                  >
                    Approve
                  </Button>
                )}
                {/^submitted$/i.test(quesAnsStatus) && (
                  <div>
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      disabled={/^trial_user$/i.test(user.roles) ? true : false}
                      onClick={() => {
                        approveReject("approved");
                      }}
                      className="blue-button"
                    >
                      Approve
                    </Button>
                    <Button
                      className="lightBlue-button ml-2"
                      variant="contained"
                      size="large"
                      color="primary"
                      disabled={/^trial_user$/i.test(user.roles) ? true : false}
                      onClick={() => {
                        approveReject("rejected");
                      }}
                    >
                      Reject
                    </Button>
                  </div>
                )}
              </Box>
            )}
          </Box>
          <div className="odr-main-table">
          <AgGridPaginatedTable
            getTableRows={getQuestionTableData}
            columns={submittedQuesAnsDetailTable}
            perPage={10}
            refreshCounter={questionsTableRefreshCount}
          />
          </div>
        </Box>
      </Paper>
    </>
  );
}
